import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as ExamInsideCircle } from "../../../../assets/svg/exam-inside-circle.svg";
import { IExam } from "../../types";
import { IconWithText } from "../IconWithText";
import { ReactComponent as Exam } from "../../../../assets/svg/exam.svg";

const useStyles = makeStyles(() => ({
  examsContainer: {
    marginTop: 16,
    border: "1px solid #C5C5C5",
    borderRadius: 15,
    padding: "16px 18px 16px 18px",
  },
  content: {
    display: "flex",
    justifyContent: "space-between",
    padding: "6px 14px",
    "&:hover": {
      backgroundColor: "#EEEFF380",
      borderRadius: 15,
    },
  },
  name: {
    fontSize: 17,
    fontWeight: 500,
    color: "#858997",
    wordBreak: "break-word",
  },
  score: {
    fontSize: 18,
    color: "#231F20",
    textAlign: "right",
    wordBreak: "break-word",
    minWidth: 200,
  },
  iconNameContainer: {
    display: "flex",
    columnGap: 8,
    alignItems: "center",
  },
}));

interface ExamsShowProps {
  exams: IExam[];
}

export const ExamsWidget: FC<ExamsShowProps> = ({ exams }) => {
  const classes = useStyles();

  return (
    <div>
      <IconWithText Icon={ExamInsideCircle} title="Exams" />
      <div className={classes.examsContainer}>
        {exams.map((exam) => (
          <div key={exam.name} className={classes.content}>
            <div className={classes.iconNameContainer}>
              <Exam />
              <div className={classes.name}>{exam.name}</div>
            </div>
            <div className={classes.score}>{exam.score}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
